/**
 * Publishes admin content changes to the public site.
 *
 * Tour pages on the web app are statically generated with a 24h `revalidate`, so
 * without this call a saved edit stays invisible until the page happens to
 * regenerate. Every content mutation calls `revalidateWebsite()` on success.
 *
 * The secret ships in the admin bundle. That is acceptable while admin is not
 * publicly deployed (`apps/web/vercel.json` disables `production/admin`) and the
 * endpoint can only purge cache — revisit if admin ever goes public.
 */

const WEB_URL = import.meta.env.VITE_WEB_URL ?? "https://openroad.nz";

export const revalidateWebsite = async (paths?: string[]): Promise<void> => {
	const secret = import.meta.env.VITE_REVALIDATE_SECRET;

	if (secret == null || secret === "") {
		console.warn(
			"VITE_REVALIDATE_SECRET is not set — the website will not be refreshed",
		);
		return;
	}

	try {
		const response = await fetch(`${WEB_URL}/api/revalidate`, {
			method: "POST",
			headers: {
				"content-type": "application/json",
				"x-revalidate-secret": secret,
			},
			body: JSON.stringify(paths != null ? { paths } : {}),
		});

		if (!response.ok) {
			console.error(
				`Failed to refresh the website: ${response.status} ${response.statusText}`,
			);
		}
	} catch (error) {
		// Never fail a save because the cache purge failed.
		console.error("Failed to refresh the website", error);
	}
};
